import type { Facet, FacetOption } from 'src/redux/productsQuery/types/Facet';
import { BrowseDataAPIFilterUID } from 'src/services/browse-data-api/constants/BrowseDataAPIFilterUID';
import type { BrowseDataAPIFilter } from 'src/services/browse-data-api/types/BrowseDataAPIFilter';
import { parseToNumberOrNull } from 'src/utils/parseToNumberOrNull';

export const PRESET_PRICE_RANGES = [
  { min: 0, max: 10 },
  { min: 10, max: 20 },
  { min: 20, max: 50 },
  { min: 50, max: 100 },
  { min: 100, max: null },
];

export const adaptPriceFacet = (facet: BrowseDataAPIFilter): Facet => {
  const manualPriceRange = {
    max: parseToNumberOrNull(facet.options[1].value as string),
    min: parseToNumberOrNull(facet.options[0].value as string),
  };

  const priceRangesWithManualRange = [...PRESET_PRICE_RANGES, manualPriceRange];

  const priceFacet: Facet = {
    active: true,
    options: priceRangesWithManualRange.map((range) => {
      const hasAnyValue = range.min !== null || range.max !== null;
      const sameAsManual = range.min === manualPriceRange.min && range.max === manualPriceRange.max;
      const bothValuesZero = range.min === 0 && range.max === 0;
      const active = hasAnyValue && sameAsManual && !bothValuesZero;

      return {
        uid: null,
        value: range.min !== null || range.max !== null ? `${range.min}-${range.max}` : null,
        title: `${range.min}-${range.max}`,
        active: active,
        activeCount: null,
        minValue: range.min,
        maxValue: range.max,
      } as FacetOption;
    }),
    title: facet.title,
    type: facet.type,
    uid: facet.uid,
  };

  return priceFacet;
};

export const adaptBrowseFilters = (browseFilters: BrowseDataAPIFilter[]): Facet[] => {
  return browseFilters.map((filter) => {
    const { defaultOption, expandedByDefault, ...restOfFilter } = filter;

    if (filter.uid === BrowseDataAPIFilterUID.Price) {
      return adaptPriceFacet(filter);
    }

    return {
      ...restOfFilter,
      options: filter.options.map((option) => {
        const { tooltip, ...restOfOption } = option;

        return {
          ...restOfOption,
          minValue: option.minValue ?? null,
          maxValue: option.maxValue ?? null,
        };
      }),
    };
  });
};
